import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";

const ALLOWED_USERS = [393797, 412000, 1178192];

const ProtectedRoute = () => {
  const { data, loading } = useAuth();

  if (loading) return <div className="preloader__wrapper" />;

  if (!data || !data.id) {
    return <Navigate to="/" replace />;
  }

  if (!ALLOWED_USERS.includes(data.id)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
